import validator from "validator";
import message from "../../../messages/ticket";

const validateTitle = (title) => {
  if (validator.isEmpty(title)) {
    return message.ADD_CATEGORY_TICKET_TITLE_DOSE_NOT_EXIST;
  }

  if (!title.trim().length) {
    return message.ADD_CATEGORY_TICKET_TITLE_DOSE_NOT_EXIST;
  }

  return true;
};

const validateFormAddCategoryTicket = (title) => {
  const resValidateTitle = validateTitle(title);
  if (resValidateTitle != true) {
    return resValidateTitle;
  }

  return true;
};

export default validateFormAddCategoryTicket;
